export default {
  RAZZLE_IMAGES_URL: 'https://wgt-dev.s3.amazonaws.com/property-value/',
};
